import {create} from "zustand"
import {ExpertModel} from "../types/ExpertModel"

type ExpertListStore = {
  expertList: undefined | ExpertModel[]
  searchExpertList: undefined | ExpertModel[]
  searchTerm?: string | undefined
  regions?: string | undefined
  setExpert: (expertList: undefined | ExpertModel[]) => void
  setSearchExpert: (searchExpertList: undefined | ExpertModel[]) => void
  setSearchTerm: (searchTerm: string | undefined) => void
  setRegion: (region: string | undefined) => void
  clearExpert: () => void
  clearSearchExpert: () => void
  clearSearchTerm: () => void
  clearRegion: () => void
}

export const expertListStore = create<ExpertListStore>((set) => ({
  expertList: undefined,
  searchExpertList: undefined,
  searchTerm: "",
  regions: "",

  setExpert: (expertList: undefined | ExpertModel[]) => {
    set({expertList})
  },
  clearExpert: () => {
    set({expertList: undefined})
  },

  setSearchExpert: (searchExpertList: undefined | ExpertModel[]) => {
    set({searchExpertList})
  },

  clearSearchExpert: () => {
    set({searchExpertList: undefined})
  },

  setSearchTerm: (searchTerm: undefined | string) => {
    set({searchTerm})
  },

  clearSearchTerm: () => {
    set({searchTerm: ""})
  },

  setRegion: (regions: undefined | string) => {
    set({regions})
  },

  clearRegion: () => {
    set({regions: ""})
  },
}))
